import { createFileRoute } from '@tanstack/react-router';
import { ErrorLayout } from '@amber-ui/core';

function OtpError() {
  return (
    <ErrorLayout disable_logout disable_reload ok_path="/" message="This link is no longer valid" />
  );
}

export const Route = createFileRoute('/otp/error')({
  component: OtpError,
});
